import type { SVGProps } from 'react';

interface Props extends Omit<SVGProps<SVGSVGElement>, 'height' | 'fill'> {
  /** Altura en píxeles. El ancho se ajusta automáticamente por el viewBox. */
  altura?: number;
}

/**
 * Logo oficial Adelante — versión de 2 tonos.
 *
 * SVG original del brand guide: dos paths con verde principal (#ADD010) en
 * primer plano y verde sombra (#88A024) atrás, dando profundidad a las
 * cuatro figuras angulares.
 *
 * Colores hardcoded a propósito: el logo corporativo no se recolorea — ni en
 * fondo oscuro ni en fondo claro mantiene esos dos verdes. Si en algún caso
 * extremo hace falta una versión monocromática, crear otro componente
 * (`<LogoAdelanteMono />`) en vez de parametrizar este.
 */
export function LogoAdelante({ className, altura = 24, ...rest }: Props) {
  return (
    <svg
      role="img"
      aria-label="Logo Adelante"
      className={className}
      height={altura}
      viewBox="0 0 745 326"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M541.795 94.8125H331.851L189.631 325.073H402.984L541.795 94.8125ZM744.966 209.943H535.022L467.299 325.073H677.242L744.966 209.943Z"
        fill="#88A024"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H208.863L402.138 325.074H189.626L0 0ZM331.846 94.8132H541.79L677.237 325.074H467.907L331.846 94.8132Z"
        fill="#ADD010"
      />
    </svg>
  );
}
